module.exports = __webpack_public_path__ + "images/drawings/drop.14a8359b303a4bc397fe0fa78b391a48.png";